export const StreamType = {
  DASH: 'dash',
  HLS: 'hls',
  PROGRESSIVE: 'progressive',
  IMAGE: 'image',
  DOCUMENT: 'document'
} as const;
